export default function () {
  return {
    columns: [
      {
        name: 'id',
        columnProps: {
          label: '应收ID',
          prop: 'id',
          width: 100,
        },
      },
      {
        name: 'content',
        columnProps: {
          label: '收款内容',
          prop: 'content',
          width: 80,
        },
      },
      {
        name: 'relReceivableId',
        columnProps: {
          label: '关联单ID',
          prop: 'relReceivableId',
        },
      },
      {
        name: 'receivableDate',
        columnProps: {
          label: '应收日期',
          prop: 'receivableDate',
          width: 100,
        },
      },
      {
        name: 'receivableAmount',
        columnProps: {
          label: '应收金额(元)',
          prop: 'receivableAmount',
          width: 110,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
      },
      {
        name: 'receivingAmount',
        columnProps: {
          label: '收款中金额(元)',
          prop: 'receivingAmount',
          width: 160,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
      },
      {
        name: 'receivedAmount',
        columnProps: {
          label: '已收金额(元)',
          prop: 'receivedAmount',
          width: 110,
        },
        getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
      },
      {
        name: 'remainAmount',
        columnProps: {
          label: '剩余应收金额(元)',
          prop: 'remainAmount',
          width: 130,
        },
        getText: ({ row }) => this.numberWithCommas(row.remainAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          label: '备注',
          prop: 'remarks',
          width: 150,
        },
      },
      {
        name: 'receivableState',
        columnProps: {
          label: '收款状态',
          prop: 'receivableState',
        },
      },
      {
        name: 'completeTime',
        columnProps: {
          label: '收款完成时间',
          prop: 'completeTime',
          width: 160,
        },
      },
      {
        name: 'changeState',
        columnProps: {
          label: '是否变更',
          prop: 'changeState',
        },
      },
    ],
    pagination: {
      pageSize: 10,
      pageNum: 1,
      total: 0,
    },
  }
}
